import type { ChatHistoryEntry } from "./constants";

/**
 * Hand-written stand-in for the conversation API.
 *
 * The agent SDK restores one host-supplied thread but does not list a user's
 * threads, so the history sidebar and mock restore response still read from
 * this file. Delete the module once the app loads real conversation history.
 */

export type DummyMessageRole = "user" | "assistant";

export type DummyMessage = {
  id: string;
  role: DummyMessageRole;
  content: string;
};

export type DummyConversation = {
  id: string;
  title: string;
  /** Shown under the title in the sidebar. */
  timeLabel: string;
  messages: DummyMessage[];
  mapView: {
    center: [number, number];
    zoom: number;
  };
};

export const DUMMY_CONVERSATIONS: DummyConversation[] = [
  {
    id: "dummy-coffee-shop-bandung",
    title: "Potential areas for a new coffee shop in Bandung",
    timeLabel: "2 hours ago",
    messages: [
      {
        id: "dummy-message-1",
        role: "user",
        content: "Find potential areas for a new coffee shop in Bandung."
      },
      {
        id: "dummy-message-2",
        role: "assistant",
        content:
          "I'm understanding the objective and identifying the information needed."
      }
    ],
    mapView: {
      center: [107.6098, -6.9175],
      zoom: 12
    }
  }
];

export const DUMMY_CHAT_HISTORY: ChatHistoryEntry[] = DUMMY_CONVERSATIONS.map(
  ({ id, title, timeLabel }) => ({ id, title, timeLabel })
);

export const findDummyConversation = (
  chatId: string | null
): DummyConversation | null =>
  DUMMY_CONVERSATIONS.find(({ id }) => id === chatId) ?? null;
